const toNumberFormat = value => {
  if (value === null) return "";
  const number = parseInt(value);

  return isNaN(number) ? "" : number.toLocaleString();
};

export default toNumberFormat;
